import BotRoute from "./pages/bot/route";
import AuthRoute from "./pages/auth/route";
import SettingsRoute from "./pages/settings/route";
import DatasetRoute from "./pages/dataset/route";
import OfficeRoute from "./pages/plugin/route";
import AdministrationRoute from "./pages/administration/route";
import HomeRoute from "./pages/home/route";
import CompanyRoute from "./pages/company/route";
import SupervisionRoute from "./pages/supervision/route";
import OtherRoute from "./pages/other/route";
import DashboardRoute from "./pages/dashboard/route";
import RoleRoute from "./pages/role/route";
import AiRoute from "./pages/ai/route";
import MemosRouge from "./pages/memos/route";

export default [
    ...OtherRoute,
    ...BotRoute,
    ...AuthRoute,
    ...SettingsRoute,
    ...DatasetRoute,
    ...OfficeRoute,
    ...AdministrationRoute,
    ...HomeRoute,
    ...CompanyRoute,
    ...SupervisionRoute,
    ...DashboardRoute,
    ...RoleRoute,
    ...AiRoute,
    ...MemosRouge,
];
